// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"4af24c09","422":"fcd67b8f"}[chunkId] + ".chunk.js";
};